module.exports = __webpack_public_path__ + "media/giving-back/responsible-41204a51.png";